import React from "react";
import { Link } from "react-router-dom";
import styles from "../../styles/landing.module.css";

const Header = () => {
  return (
    <header className={styles.landingHeader}>
      <div className={styles.logoContainer}>
        <a href="#top">
          <img 
            src="/MemCurveLogo1.png" 
            alt="Memory Curve Logo" 
            className={styles.logo} 
          />
          <h1>Memory Curve</h1>
        </a>
      </div>
      <nav className={styles.navigation}>
        <ul>
          <li><a href="#pricing">Pricing</a></li>
          <li><a href="#scientific-back">Scientific Background</a></li>
          <li><a href="#faq">FAQ</a></li>
        </ul>
      </nav>
      <div className={styles.authButtons}>
        <Link to="/login" className={styles.loginButton}>Login</Link>
      </div>
    </header>
  );
};

export default Header; 